import { Capacitor, Plugins } from '@capacitor/core';
import { NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import {
  NavController,
  AlertController,
  ModalController, IonicModule, ActionSheetController, IonSelect
} from '@ionic/angular';
import ecosystemJson from 'src/assets/plantillas/ecosistemdata.json';
import socialJson from 'src/assets/plantillas/ver/data-social.json';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { GoogleAccountAuthService } from 'src/app/services/auth/google-account-auth.service';
import { CameraServiceService } from 'src/app/services/multimedia/camera-service.service';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { isVideo, isImage } from 'src/app/utils';
import Swal2 from 'sweetalert2';
import { ExistingPublicationMedia, UploadMultimediaService } from './../../services/upload/upload-multimedia.service';
import { CameraService } from 'src/app/services/multimedia/capacitor-camera/camera.service';
//import { Filesystem, Directory } from '@capacitor/filesystem';
//import { Media, MediaFetchOptions } from '@capacitor-community/media';
//import { CameraPreview, CameraPreviewOptions } from '@capacitor-community/camera-preview';
import { Camera, CameraResultType, CameraSource, Photo, CameraOptions } from '@capacitor/camera';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // Import the Router
import { RequestService } from 'src/app/services/request/request.service';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { SliderInformationComponent } from 'src/app/components/slider-information/slider-information.component';
import { InputAlertControllerService } from 'src/app/services/utils/input-alert-controller.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { PagoVerificacionComponent } from 'src/app/components/pago-verificacion/pago-verificacion.component';
import { HistoryViewComponent } from 'src/app/components/history-view/history-view.component';
defineCustomElements(window);

declare var google;
declare var gapi;
declare var Google;

interface PublicationFlowParticle {
  x: number;
  y: number;
  lane: number;
  speed: number;
  size: number;
  color: string;
}

interface SpotifyPostTrack {
  id: string;
  uri: string;
  name: string;
  artists: string[];
  album: string;
  artwork_url: string | null;
  external_url: string | null;
  duration_ms: number | null;
}

@Component({
  selector: 'app-create-publication',
  templateUrl: './create-publication.page.html',
  styleUrls: ['./create-publication.page.scss'],
})
export class CreatePublicationPage implements OnInit, AfterViewInit, OnDestroy {
	showCommunityGuidelines = false;
	private communityGuidelinesStorageKey = '';
  isToggleChecked;
  listaDivisas=[

   
    {
      id:104,
      name:"MXN",
      valor: 1000,
      conversion:100
    },
  ];

  audio_preview_set:boolean=true;
  audio_blob_set:boolean=false;
  setDrive_media_called:boolean=false;
  setDrive_media;
  private apiKey = 'AIzaSyDKzCRYNscPNGWIGhsVZdFk-q-QuQmDjEs'; // Replace with your actual API Key
  private placesRetryTimer?: ReturnType<typeof setTimeout>;
  private scope = 'https://www.googleapis.com/auth/drive.readonly';

  private oauthToken: string='sbjcbjdcs';
  user_id;
  profile_id;

  audio_start_value: number = 0;
  endValue: number = 30; // or any default value you want
  audio_duration=30;
  rangeValues: any = { lower: this.audio_start_value, upper: this.endValue };
  timeoutId;
  @ViewChild('selectTrigger', { static: false }) selectTrigger: IonSelect;
  @ViewChild('publicationFlow') publicationFlow?: ElementRef<HTMLCanvasElement>;
  @Input() entrelazamiento: boolean = false;
  mediaType: string;
  public selectedEcosystem: string = '';
  public ecosystemdata: Array<string> = Object.keys(ecosystemJson.ecosistema);
  public socialdata: Array<string> = Object.keys(socialJson.Social);
  public multimedia: Array<MediaItem> = new Array<MediaItem>();
  mediaPath: string;
  nameFile: string;
  
  ruta: Array<object> = [];
  rutImage: any;
  rutaImagen: Array<string>=[];
  public siguiente: boolean = false;
  validar: boolean = false;
  blobTrailer;
  rutaPortada : any;

  isPickedImage: boolean = false;
  isPickedVideo: boolean = false;
  public isCameraCalled = false;
public isVideoCalled = false;
  public publicationDetailsVisible = false;
  private normalComposerOpen = false;
  private normalComposerAutoOpened = false;
  private normalComposerPreviewUrls: string[] = [];
  public welcomeFirstPost = false;
  public spotifyTrackQuery = '';
  public spotifyTrackResults: SpotifyPostTrack[] = [];
  public spotifyTrackLoading = false;
  private spotifyTrackSearchTimeout?: ReturnType<typeof setTimeout>;
  private spotifyTrackSearchRequest = 0;
  selectedMediaSrc: string;
  public readonly mediaPlaceholder = 'https://cdn-icons-png.flaticon.com/512/1329/1329925.png';
  private flowParticles: PublicationFlowParticle[] = [];
  private flowAnimationFrame = 0;
  private flowLastFrame = 0;
  private flowResizeObserver?: ResizeObserver;
  private flowVisibilityHandler?: () => void;
  private flowReducedMotion = false;
  constructor(
    private walletService: WalletServiceService,
    private cameraService: CameraServiceService,
    public formservice: FormServiceService,
    public modalController: ModalController,
    public navCtrl: NavController,
    public alertController: AlertController,
    public uploadMedia: UploadMultimediaService,
    private cameraCapacitor:CameraService,
    private uploadMultimediaService: UploadMultimediaService,
    private actionSheetController: ActionSheetController,
    private sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private request: RequestService,
    private inputAlertController: InputAlertControllerService,
    public https: HttpClient,
    private faio:FingerprintAIO,
    private googleAccountAuth: GoogleAccountAuthService,

  ) {  this.rangeValues = { lower: this.audio_start_value, upper: this.endValue };}
  openIonSelect(event){
    console.log(event);

    this.selectTrigger.open();
    }
    private showSliderInformationModal() {
      this.inputAlertController.OkInfoMessage(
        'Usuario no verificado',
        'Esta característica solo está disponible para usuarios verificados, sigue los pasos en la sección de configuración de la cuenta y completa la verificación de la cuenta para acceder a esta funcionalidad',
        'Ir a completar mi perfil'
      );
      this.modalController.create({
canDismiss: true,
        component: SliderInformationComponent,
        componentProps: {
        pr: this.formservice.profile,
        },
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      }
      cambio($event){
        //this.openKYCApplicationModal();
        this.onClick();
          }
          private openKYCApplicationModal() {
            console.log('openKYCApplicationModal called');
            this.walletService.KYC_validation().then((result_kyc) => {
              console.log('KYC_validation result:', result_kyc);
              if (result_kyc['permit']) {
              this.showWalletAppModal();
              } else if (this.formservice.profile.kyc === "Sin Validar") {
                this.isToggleChecked = false;
              this.showPagoVerificacionModal();
              } else {
                this.isToggleChecked = false;
              this.showPagoVerificacionModal();
        
              }
            }).catch((error) => {
              console.error('KYC_validation error:', error);
              console.error(error);
            });
            }
            onClick() {
              if (Capacitor.getPlatform() !== 'web') {
              this.faio.show({
                title: "Leyendo huella Digital",
                subtitle: "Use su huella para permitir el acceso a retiros",
              })
                .then((res) => {
      
                      
                      this.openKYCApplicationModal();
             
                  console.log(res);
              
              
                })
                .catch((err) => {
                  console.log(err);

                  alert(err);
                });
              }else{
                this.openKYCApplicationModal();
              }
            }
            private showWalletAppModal() {
              if (this.walletService.SubscriptionExpired !== true){
             // if (!this.HubbleExpired){
               // this.HubbleExpired = true;
          // Set the authorization response status
          // Set the authorization response status
          this.validar=!this.validar;
          this.formservice.normalpublication.current_multimedia_status = this.validar;
          console.log(this.validar);
            console.log('showWalletAppModal called');
        
          // Set HubbleExpired to false after 6 seconds
          //setTimeout(() => {
            //this.HubbleExpired = false;
            //console.log('HubbleExpired set to false');
          //}, 6000);
        
             // }
            } else if (this.walletService.SubscriptionExpired === true){
              this.isToggleChecked = false;
             // this.RenewSuscription();
             this.showPagoVerificacionModal();
              Swal2.fire({
                title: 'You must renew your subscription',
                text: "Your subscription has expired. Renew it to access this feature.",
                icon: 'info',
              //  showCancelButton: true,
                confirmButtonColor: '#3085d6',
                background: '#010f4e',
                position: 'top-end',
                timerProgressBar: true,
                toast: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel'
              });
            }
          
          
            }
            private showPagoVerificacionModal() {
              console.log('showPagoVerificacionModal called');
              console.log("entro al else if ");
              
              this.modalController.create({
                component: PagoVerificacionComponent,
                cssClass: 'detailsInModal',
                canDismiss: true, // (forced globally for swipe close on all modals)
                componentProps: {
                pr: this.formservice.profile
                }
              }).then((modal) => {
                modal.present();
              });
              }

public openPremiumVerification() {
  if (!this.formservice?.profile) {
    Swal2.fire({
      title: 'Inicia sesión',
      text: 'Necesitas iniciar sesión para activar Premium.',
      icon: 'info',
      timer: 4200,
      timerProgressBar: true,
      toast: true,
      position: 'top-start',
      showConfirmButton: false,
      background: '#010f4e',
      color: '#ffffff',
    });
    this.router.navigate(['/login']);
    return;
  }

  if (this.formservice.profile?.kyc === 'Validado') {
    Swal2.fire({
      title: 'Premium activo',
      text: 'Tu perfil ya está verificado.',
      icon: 'success',
      timer: 3600,
      timerProgressBar: true,
      toast: true,
      position: 'top-start',
      showConfirmButton: false,
      background: '#010f4e',
      color: '#ffffff',
    });
    return;
  }

  this.showPagoVerificacionModal();
}
modify_publicaction_type(event: CustomEvent){
  this.walletService.KYC_validation().then((result_kyc) => {
    if (result_kyc['permit']) {
      Swal2.fire({
        title: 'Publication type updated',
        text: "The publication type was updated successfully.",
        icon: 'info',
      //  showCancelButton: true,
        confirmButtonColor: '#3085d6',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      });
      this.formservice.publication_type= event.detail.value;
      this.selectedEcosystem = this.formservice.publication_type;
      this.showFirstNormalPostGuidelines();
    }  else  {
      this.showPagoVerificacionModal();
  
    }
  }).catch((error) => {
    console.error(error);
  });
 
}
ngOnDestroy(){
    if (this.placesRetryTimer) clearTimeout(this.placesRetryTimer);
    this.destroyPublicationFlow();
    this.normalComposerPreviewUrls.forEach(url => URL.revokeObjectURL(url));
    this.formservice.Capacitor_convertFileSrc=null;
    this.formservice.Capacitor_convertFileSrc_video=null;
    clearInterval(this.setDrive_media);
}
  get selectedMediaCount(): number {
    return this.formservice?.normalpublication?.blobsMultimedia?.length || 0;
  }

  get hasUploadedMedia(): boolean {
    return Boolean(
      this.formservice?.Capacitor_convertFileSrc ||
      this.formservice?.Capacitor_convertFileSrc_video ||
      this.formservice?.multimedia?.length ||
      this.formservice?.normalpublication?.blobsMultimedia?.length
    );
  }

  /** Music can accompany image posts only. Videos already contain their own audio. */
  get canAttachSpotifyMusic(): boolean {
    if (this.selectedEcosystem !== 'normal') return false;
    const media = this.formservice?.normalpublication?.blobsMultimedia || [];
    return media.length > 0 && media.every((item: any) => this.isImagePostMedia(item));
  }

  get hasPostMediaButMusicIsUnavailable(): boolean {
    return this.selectedEcosystem === 'normal'
      && (this.formservice?.normalpublication?.blobsMultimedia?.length || 0) > 0
      && !this.canAttachSpotifyMusic;
  }

  private isImagePostMedia(item: any): boolean {
    const mimeType = String(item?.mimeType || item?.blob?.type || '').toLowerCase();
    if (mimeType) return mimeType.startsWith('image/');
    const name = String(item?.filename || item?.remoteUrl || '').split('?')[0].toLowerCase();
    return /\.(avif|gif|jpe?g|png|webp)$/.test(name);
  }

  onSpotifyTrackQueryChange(query: string): void {
    this.spotifyTrackQuery = String(query || '');
    if (this.spotifyTrackSearchTimeout) clearTimeout(this.spotifyTrackSearchTimeout);

    const searchTerm = this.spotifyTrackQuery.trim();
    if (searchTerm.length < 2) {
      this.spotifyTrackSearchRequest++;
      this.spotifyTrackResults = [];
      this.spotifyTrackLoading = false;
      return;
    }

    this.spotifyTrackSearchTimeout = setTimeout(() => {
      this.searchSpotifyTracks(searchTerm);
    }, 350);
  }

  private async searchSpotifyTracks(searchTerm: string): Promise<void> {
    const requestId = ++this.spotifyTrackSearchRequest;
    this.spotifyTrackLoading = true;
    try {
      let response: any = await this.request.createRequestPost('spotify_search', {
        text: searchTerm,
        market: 'MX',
      });
      if (typeof response === 'string') response = JSON.parse(response);
      // The web request service uses fetch, whose completion can run outside
      // Angular's render cycle. Also support the native/legacy response
      // wrappers so a valid Spotify response is never silently discarded.
      const items = response?.data?.tracks?.items
        || response?.tracks?.items
        || response?.data?.data?.tracks?.items
        || response?.body?.tracks?.items
        || response?.body?.data?.tracks?.items
        || [];
      if (requestId !== this.spotifyTrackSearchRequest) return;
      this.spotifyTrackResults = items
        .filter((track: any) => track?.id && track?.uri && track?.name)
        .slice(0, 8)
        .map((track: any): SpotifyPostTrack => ({
          id: String(track.id),
          uri: String(track.uri),
          name: String(track.name),
          artists: (track.artists || []).map((artist: any) => String(artist?.name || '')).filter(Boolean),
          album: String(track.album?.name || ''),
          artwork_url: track.album?.images?.[0]?.url || null,
          external_url: track.external_urls?.spotify || null,
          duration_ms: Number.isFinite(track.duration_ms) ? Number(track.duration_ms) : null,
        }));
      this.ref.detectChanges();
    } catch (error) {
      if (requestId !== this.spotifyTrackSearchRequest) return;
      console.warn('Spotify track search failed:', error);
      this.spotifyTrackResults = [];
      this.ref.detectChanges();
    } finally {
      if (requestId === this.spotifyTrackSearchRequest) {
        this.spotifyTrackLoading = false;
        this.ref.detectChanges();
      }
    }
  }

  selectSpotifyTrack(track: SpotifyPostTrack): void {
    if (!this.canAttachSpotifyMusic) return;
    this.formservice.normalpublication.spotify_track = { ...track };
    this.spotifyTrackResults = [];
    this.spotifyTrackQuery = '';
  }

  removeSpotifyTrack(): void {
    this.formservice.normalpublication.spotify_track = null;
    this.spotifyTrackResults = [];
    this.spotifyTrackQuery = '';
  }

  /**
   * Adds one already-uploaded Laniakea/Wix media URL to the normal publication
   * wizard. The publication still collects its title, description, location,
   * premium setting and social destinations; only the S3 upload is bypassed.
   *
   * The internal array-shaped state is intentional so this can be expanded to
   * multiple remote URLs later without changing the publication contract.
   */
  public useExistingMediaUrl(mediaUrl: string, isPremium: boolean = false): boolean {
    let remoteMedia: ExistingPublicationMedia;

    try {
      remoteMedia = this.uploadMultimediaService.prepareExistingPublicationMedia(mediaUrl);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'La URL de multimedia no es válida.';
      Swal2.fire({
        title: 'Multimedia no válida',
        text: message,
        icon: 'warning',
        confirmButtonText: 'Entendido',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      return false;
    }

    const mediaEntry = {
      blob: remoteMedia,
      filename: remoteMedia.filename,
      isPremium,
      source: remoteMedia.source,
      remoteUrl: remoteMedia.remoteUrl,
      mimeType: remoteMedia.mimeType,
    };

    // One URL is supported by the current UX. Keeping it in the existing array
    // preserves the normal posting pipeline and prepares it for multiple URLs.
    this.formservice.normalpublication.blobsMultimedia = [mediaEntry];
    this.formservice.normalpublication.doesItHaveMultimedia = true;
    this.formservice.normalpublication.current_multimedia_status = isPremium;
    this.formservice.multimedia = [];

    const isVideoUrl = remoteMedia.mimeType.startsWith('video/');
    this.formservice.Capacitor_convertFileSrc = isVideoUrl ? null : remoteMedia.remoteUrl;
    this.formservice.Capacitor_convertFileSrc_video = isVideoUrl ? remoteMedia.remoteUrl : null;
    this.selectedMediaSrc = remoteMedia.remoteUrl;
    this.isPickedImage = !isVideoUrl;
    this.isPickedVideo = isVideoUrl;
    this.publicationDetailsVisible = true;
    this.ref.detectChanges();
    this.openWelcomeFirstPostPreviewWhenMediaReady();

    return true;
  }

  public async promptForExistingMediaUrl(): Promise<boolean> {
    const result = await Swal2.fire({
      title: 'Usar multimedia ya subida',
      text: 'Pega una URL pública de imagen o video alojada en Laniakea o Wix.',
      input: 'url',
      inputPlaceholder: 'https://static.wixstatic.com/media/...png',
      inputAttributes: {
        autocapitalize: 'off',
        autocorrect: 'off',
        spellcheck: 'false',
      },
      showCancelButton: true,
      confirmButtonText: 'Usar esta multimedia',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0a5cff',
      cancelButtonColor: '#3b3f4a',
      color: '#ffffff',
      background: '#010f4e',
      allowOutsideClick: false,
      preConfirm: (value) => {
        try {
          return this.uploadMultimediaService.prepareExistingPublicationMedia(String(value || '')).remoteUrl;
        } catch (error) {
          const message = error instanceof Error ? error.message : 'La URL de multimedia no es válida.';
          Swal2.showValidationMessage(message);
          return false;
        }
      },
    });

    if (!result.isConfirmed || !result.value) {
      return false;
    }

    return this.useExistingMediaUrl(String(result.value));
  }

  continueToPublicationDetails(): void {
    if (this.hasUploadedMedia) {
      if (!this.canAttachSpotifyMusic) this.removeSpotifyTrack();
      this.publicationDetailsVisible = true;
    }
  }

  ngOnInit() {
    this.publicationDetailsVisible = false;
    localStorage.removeItem('fileId');

    this.profile_id = this.formservice.profile?.id;
    if (this.profile_id) {
      localStorage.setItem('profile_id', this.profile_id);
    }

    console.log('Entrando a oninit create publication', this.profile_id);
    this.rutaPortada = '';
    this.formservice.multimedia = [];
    this.formservice.is_feed = true;
    const queryParams = this.route.snapshot.queryParamMap;
    const queryEntrelazamiento = queryParams.get('entrelazamiento');
    this.entrelazamiento = queryEntrelazamiento === 'true' || queryEntrelazamiento === '1';
    this.welcomeFirstPost = queryParams.get('welcomeFirstPost') === '1';

    const queryPublicationType = queryParams.get('publicationType') || queryParams.get('publication_type');
    if (queryPublicationType) {
      this.formservice.publication_type = queryPublicationType;
    }

    this.selectedEcosystem = this.formservice.publication_type;
    setTimeout(() => {
      this.showFirstNormalPostGuidelines();
      this.maybeOpenInitialNormalComposer();
    }, 0);
    this.route.queryParamMap.subscribe((params) => {
      const publicationTypeFromParams = params.get('publicationType') || params.get('publication_type');
      if (publicationTypeFromParams) {
        this.formservice.publication_type = publicationTypeFromParams;
        this.selectedEcosystem = publicationTypeFromParams;
      }
			this.welcomeFirstPost = params.get('welcomeFirstPost') === '1';
    });
    console.log(this.selectedEcosystem);
    this.uploadMedia.image = '';
    console.log("siguiente create",this.siguiente);

  }

	private openWelcomeFirstPostPreviewWhenMediaReady(attempt = 0): void {
		if (!this.welcomeFirstPost) return;

		if (this.hasUploadedMedia) {
			this.publicationDetailsVisible = true;
			this.siguiente = true;
			this.ref.detectChanges();
			return;
		}

		if (attempt < 20) {
			setTimeout(() => this.openWelcomeFirstPostPreviewWhenMediaReady(attempt + 1), 150);
		}
	}

  private showFirstNormalPostGuidelines(): void {
    if (this.entrelazamiento || this.selectedEcosystem !== 'normal') return;
    const profileKey = this.profile_id || 'guest';
    const storageKey = `community-guidelines-normal-post-v1:${profileKey}`;
    if (localStorage.getItem(storageKey) === 'accepted') return;

	this.communityGuidelinesStorageKey = storageKey;
	this.showCommunityGuidelines = true;
  }

	acceptCommunityGuidelines(): void {
		if (this.communityGuidelinesStorageKey) {
			localStorage.setItem(this.communityGuidelinesStorageKey, 'accepted');
		}
		this.showCommunityGuidelines = false;
		setTimeout(() => this.maybeOpenInitialNormalComposer(), 0);
	}

  private maybeOpenInitialNormalComposer(): void {
    if (Capacitor.getPlatform() !== 'ios' || this.entrelazamiento ||
        this.selectedEcosystem !== 'normal' || this.showCommunityGuidelines ||
        this.normalComposerAutoOpened || this.hasUploadedMedia) return;
    this.normalComposerAutoOpened = true;
    void this.openNormalMediaComposer(true);
  }

  private async openNormalMediaComposer(initial = false): Promise<void> {
    if (this.normalComposerOpen) return;
    this.normalComposerOpen = true;
    try {
      await NativeLiquidGlass.setChromeSuppressed({ suppressed: true }).catch(() => undefined);
      const modal = await this.modalController.create({
        component: HistoryViewComponent,
        componentProps: { composerMode: 'social' },
        cssClass: 'story-creation-modal',
        canDismiss: true,
      });
      await modal.present();
      const { data, role } = await modal.onDidDismiss();
      if (role === 'selected' && data?.blob instanceof Blob && data.blob.size) {
        this.addNormalMedia(data.blob, data.filename, data.type);
      } else if (initial && !this.hasUploadedMedia) {
        this.back();
      }
    } catch (error) {
      console.error('Unable to open social media composer', error);
      this.normalComposerAutoOpened = false;
    } finally {
      this.normalComposerOpen = false;
      await NativeLiquidGlass.setChromeSuppressed({ suppressed: false }).catch(() => undefined);
      await NativeLiquidGlass.restoreRegions().catch(() => undefined);
    }
  }

  private addNormalMedia(blob: Blob, filename: string, type: 'image' | 'video'): void {
    const safeType = type === 'video' ? 'video' : 'image';
    const safeFilename = filename || `social-${Date.now()}.${safeType === 'video' ? 'mp4' : 'jpg'}`;
    const previewUrl = URL.createObjectURL(blob);
    this.normalComposerPreviewUrls.push(previewUrl);
    this.uploadMedia.blob = blob;
    this.uploadMedia.filename = safeFilename;
    this.formservice.normalpublication.blobsMultimedia ||= [];
    this.formservice.normalpublication.blobsMultimedia.push({ blob, filename: safeFilename, isPremium: false });
    this.formservice.normalpublication.doesItHaveMultimedia = true;
    this.formservice.multimedia.push(new MediaItem({
      type: blob.type || (safeType === 'video' ? 'video/mp4' : 'image/jpeg'),
      name: safeFilename,
      size: blob.size,
      status: 'Esperando Media',
    }));
    this.formservice.Capacitor_convertFileSrc = safeType === 'image' ? previewUrl : null;
    this.formservice.Capacitor_convertFileSrc_video = safeType === 'video' ? previewUrl : null;
    this.selectedMediaSrc = previewUrl;
    this.isPickedImage = safeType === 'image';
    this.isPickedVideo = safeType === 'video';
    if (!this.canAttachSpotifyMusic) this.removeSpotifyTrack();
    this.publicationDetailsVisible = true;
    this.ref.detectChanges();
    this.openWelcomeFirstPostPreviewWhenMediaReady();
  }

	declineCommunityGuidelines(): void {
		this.showCommunityGuidelines = false;
		this.back();
	}
  private handlePlaceChanged(
    autocomplete: google.maps.places.Autocomplete,
   
    inputValue: string
  ) {

  
    const place = autocomplete.getPlace();
          // Calculate and display the route
          const startPointInput = document.getElementById('pac-input') as HTMLInputElement;
    console.log('place',place);
    console.log('startPointInput',startPointInput);
    this.formservice.ubicacion = startPointInput.value;
    this.formservice.normalpublication.ubicacion=this.formservice.ubicacion;
    this.formservice.lkpublication.ubicacion = this.formservice.ubicacion;
    this.formservice.landpublication.ubicacion = this.formservice.ubicacion;
    this.formservice.epochpublication.ubicacion = this.formservice.ubicacion;
    this.formservice.eventospublication.ubicacion = this.formservice.ubicacion;
    this.formservice.earthpublication.ubicacion = this.formservice.ubicacion;


  }
  ngAfterViewInit(){
    requestAnimationFrame(() => this.initializePublicationFlow());
    this.initializePlaceAutocomplete();
    const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
    if (this.formservice.Capacitor_convertFileSrc && imagePreviewElement){
    setTimeout(() => {
      if (this.formservice.Capacitor_convertFileSrc){
        imagePreviewElement.src =this.formservice.Capacitor_convertFileSrc;
      }

  }, 999);
}else if (imagePreviewElement) {
  imagePreviewElement.src = this.mediaPlaceholder;
}
const videoPreviewElement = document.getElementById("videoSource") as HTMLVideoElement;
if (videoPreviewElement) {
  videoPreviewElement.muted = true;
  videoPreviewElement.defaultMuted = true;
}
if (this.formservice.Capacitor_convertFileSrc_video && videoPreviewElement){
  setTimeout(() => {
    if (this.formservice.Capacitor_convertFileSrc_video){
      videoPreviewElement.src =this.formservice.Capacitor_convertFileSrc_video;
    }
  }, 999);
}
  }

  private initializePlaceAutocomplete(attempt = 0): void {
    const input = document.getElementById('pac-input') as HTMLInputElement | null;
    if (!input) return;
    const maps = (window as any).google?.maps;
    if (!maps?.places?.Autocomplete) {
      // AppComponent loads Maps after startup. Keep the composer usable while it loads.
      if (attempt < 60) {
        this.placesRetryTimer = setTimeout(() => this.initializePlaceAutocomplete(attempt + 1), 250);
      }
      return;
    }
    const options = {
      fields: ['formatted_address', 'geometry', 'name'],
      strictBounds: false,
    };
    const autocomplete = new maps.places.Autocomplete(input, options);
    autocomplete.addListener('place_changed', () => {
      this.handlePlaceChanged(autocomplete, input.value);
    });
  }

  private initializePublicationFlow(): void {
    const canvas = this.publicationFlow?.nativeElement;
    if (!canvas || this.flowAnimationFrame) {
      return;
    }

    this.flowReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.flowResizeObserver = new ResizeObserver(() => this.layoutPublicationFlow());
    this.flowResizeObserver.observe(canvas);
    this.flowVisibilityHandler = () => {
      if (document.hidden) {
        cancelAnimationFrame(this.flowAnimationFrame);
        this.flowAnimationFrame = 0;
        this.flowLastFrame = 0;
      } else if (!this.flowReducedMotion && !this.flowAnimationFrame) {
        this.flowAnimationFrame = requestAnimationFrame((time) => this.renderPublicationFlow(time));
      }
    };
    document.addEventListener('visibilitychange', this.flowVisibilityHandler);
    this.layoutPublicationFlow();
  }

  private layoutPublicationFlow(): void {
    const canvas = this.publicationFlow?.nativeElement;
    const context = canvas?.getContext('2d');
    if (!canvas || !context) {
      return;
    }

    const bounds = canvas.getBoundingClientRect();
    const density = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.max(1, Math.round(bounds.width * density));
    canvas.height = Math.max(1, Math.round(bounds.height * density));
    context.setTransform(density, 0, 0, density, 0, 0);

    const count = Math.max(120, Math.min(420, Math.round(bounds.width * bounds.height / 700)));
    const colors = [
      'rgba(122,249,255,.68)',
      'rgba(152,168,255,.58)',
      'rgba(198,181,253,.52)',
      'rgba(255,205,178,.42)',
    ];
    this.flowParticles = Array.from({ length: count }, (_, index) => ({
      x: Math.random() * bounds.width,
      y: Math.random() * bounds.height,
      lane: (Math.random() * 2 - 1) * bounds.height * .46,
      speed: .72 + Math.random() * .85,
      size: .65 + Math.random() * 1.35,
      color: colors[index % colors.length],
    }));

    context.clearRect(0, 0, bounds.width, bounds.height);
    if (this.flowReducedMotion) {
      for (let index = 0; index < 70; index++) {
        this.stepPublicationFlow(1 / 30, bounds.width, bounds.height);
        this.drawPublicationFlow(context, bounds.width, bounds.height);
      }
      return;
    }

    cancelAnimationFrame(this.flowAnimationFrame);
    this.flowLastFrame = 0;
    this.flowAnimationFrame = requestAnimationFrame((time) => this.renderPublicationFlow(time));
  }

  private renderPublicationFlow(time: number): void {
    const canvas = this.publicationFlow?.nativeElement;
    const context = canvas?.getContext('2d');
    if (!canvas || !context || document.hidden) {
      this.flowAnimationFrame = 0;
      return;
    }

    const bounds = canvas.getBoundingClientRect();
    const delta = this.flowLastFrame ? Math.min((time - this.flowLastFrame) / 1000, .05) : 1 / 60;
    this.flowLastFrame = time;
    this.stepPublicationFlow(delta, bounds.width, bounds.height);
    this.drawPublicationFlow(context, bounds.width, bounds.height);
    this.flowAnimationFrame = requestAnimationFrame((nextTime) => this.renderPublicationFlow(nextTime));
  }

  private stepPublicationFlow(delta: number, width: number, height: number): void {
    const attractorX = width * .76;
    const attractorY = height * .46;
    for (const particle of this.flowParticles) {
      const dx = particle.x - attractorX;
      const targetY = attractorY + particle.lane * Math.min(1, Math.abs(dx) / Math.max(width, 1));
      const velocityX = -Math.tanh(dx / Math.max(width * .055, 1)) * (22 + 18 / (.35 + Math.abs(dx) / Math.max(width, 1)));
      const velocityY = (targetY - particle.y) * .72 + Math.sin(particle.x * .018 + particle.lane) * 2.2;
      particle.x += velocityX * delta * particle.speed;
      particle.y += velocityY * delta * particle.speed;

      const distance = Math.hypot(dx, particle.y - attractorY);
      if (distance < 8 || particle.x < -24 || particle.x > width + 24 || particle.y < -24 || particle.y > height + 24) {
        particle.x = Math.random() < .76 ? -8 : width + 8;
        particle.lane = (Math.random() * 2 - 1) * height * .46;
        particle.y = attractorY + particle.lane;
      }
    }
  }

  private drawPublicationFlow(context: CanvasRenderingContext2D, width: number, height: number): void {
    context.globalCompositeOperation = 'destination-out';
    context.fillStyle = 'rgba(0,0,0,.075)';
    context.fillRect(0, 0, width, height);
    context.globalCompositeOperation = 'lighter';
    for (const particle of this.flowParticles) {
      context.fillStyle = particle.color;
      context.fillRect(particle.x, particle.y, particle.size, particle.size);
    }
    context.globalCompositeOperation = 'source-over';
  }

  private destroyPublicationFlow(): void {
    cancelAnimationFrame(this.flowAnimationFrame);
    this.flowAnimationFrame = 0;
    this.flowResizeObserver?.disconnect();
    this.flowResizeObserver = undefined;
    if (this.flowVisibilityHandler) {
      document.removeEventListener('visibilitychange', this.flowVisibilityHandler);
      this.flowVisibilityHandler = undefined;
    }
  }

  public isVideo(url: string) {
    Capacitor.convertFileSrc(url);
    return isVideo(url);
  }
  
  public isImage(url: string){
    Capacitor.convertFileSrc(url);
    return isImage(url);
  }


  is_feed() {
    this.validar = !this.validar;

  }

  public setMultimediaCamera2(mediaItem: MediaItem) {
    console.log("setMultimediaCamera function called");
    const imagePath = mediaItem.mediaPath + mediaItem.nameFile;
    console.log("Captured image path:", imagePath);
    this.uploadMedia.image = Capacitor.convertFileSrc(imagePath);
    this.uploadMedia
      .readBlobFile(imagePath)
      .then(() => {
        console.log("Inside readBlobFile then block");
        if (this.selectedEcosystem === 'normal' && this.multimedia.length > 0) {
          console.log("Inside normal ecosystem condition");
          this.rutaPortada = { image: this.uploadMedia.image };
          this.multimedia[0] = this.rutaPortada;
        } else {
          this.rutaPortada = { image: this.uploadMedia.image };
          this.multimedia.push(this.rutaPortada);
        }
        /*
        if (
          this.formservice.normalpublication.blobsMultimedia.length > 0 &&
          this.selectedEcosystem === 'video'
        ) {
          console.log("Inside video ecosystem condition");
          this.formservice.normalpublication.blobsMultimedia[0] = {
            blob: this.uploadMedia.blob,
            isPremium: false,
            filename: this.uploadMedia.filename,
          };
        } else {*/
          this.formservice.normalpublication.blobsMultimedia.push({
            blob: this.uploadMedia.blob,
            isPremium: false,
            filename: this.uploadMedia.filename,
          });
     //   }
        console.log("Updated rutaPortada:", this.rutaPortada);
        return Promise.resolve();
      })
      .catch((error) => {
        console.log("Inside readBlobFile catch block:", error);
        return Promise.reject(error);
      });
  }
  
  public setMultimediaCamera(mediaItem: MediaItem) {
    
    console.log("setMultimediaCamera function called");
    const imagePath = mediaItem.mediaPath + mediaItem.nameFile;
    console.log("Captured image path:", imagePath);
    this.uploadMedia.image = Capacitor.convertFileSrc(imagePath);
    this.rutaPortada = { image: this.uploadMedia.image };
    this.formservice.Capacitor_convertFileSrc = this.uploadMedia.image;
    this.formservice.Capacitor_convertFileSrc_video = null;
    this.uploadMedia.blob = mediaItem.mediaPath;
    this.uploadMedia.filename =  mediaItem.nameFile;
    if (this.formservice.multimedia.length > 0) {
      console.log("Inside  ecosystem condition");
      this.formservice.multimedia[0] = this.rutaPortada;
    } else {
      this.formservice.multimedia.push(this.rutaPortada);
    }
    if(this.formservice.normalpublication.blobsMultimedia.length < 1){
      this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
    }else {
      this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
    }
  
    console.log("Updated rutaPortada:", this.rutaPortada);
  
    // Set the image source in the HTML
    const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
    if (imagePreviewElement) {
      imagePreviewElement.src = this.uploadMedia.image;
    }
  }
  
  
  
  
  
  

  setMultimediaVideo2(mediaItem: MediaItem) {
    
    this.uploadMedia.image = Capacitor.convertFileSrc(mediaItem.mediaPath + mediaItem.nameFile);
    this.formservice.Capacitor_convertFileSrc = null;
    this.formservice.Capacitor_convertFileSrc_video = this.uploadMedia.image;
    const videoSourceElement = document.getElementById("videoSource") as HTMLVideoElement;
  if (videoSourceElement) {
    videoSourceElement.muted = true;
    videoSourceElement.defaultMuted = true;
    videoSourceElement.src = this.uploadMedia.image;
  }
    this.uploadMedia.readBlobFile(mediaItem.mediaPath + mediaItem.nameFile).
    then((result)=>{
      if (this.formservice.multimedia.length >0){
        this.rutImage={image: this.uploadMedia.image};
        this.formservice.multimedia[0]= (this.rutImage);
      }else {
        this.rutImage={image: this.uploadMedia.image};
        this.formservice.multimedia.push(this.rutImage);
      }
      if(this.formservice.normalpublication.blobsMultimedia.length > 0 ){ //&& this.selectedEcosystem === 'normal'
        this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
      }else{
        this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
      }
    });
  }

  setMultimediaVideo(mediaItem: MediaItem) {
    
    this.uploadMedia.image = Capacitor.convertFileSrc(mediaItem.mediaPath + mediaItem.nameFile);
    this.formservice.Capacitor_convertFileSrc = null;
    this.formservice.Capacitor_convertFileSrc_video = this.uploadMedia.image;
    const videoSourceElement = document.getElementById("videoSource") as HTMLVideoElement;
  if (videoSourceElement) {
    videoSourceElement.muted = true;
    videoSourceElement.defaultMuted = true;
    videoSourceElement.src = this.uploadMedia.image;
  }
  this.uploadMedia.blob = mediaItem.mediaPath;
  this.uploadMedia.filename =  mediaItem.nameFile;
      if (this.formservice.multimedia.length >0){
        this.rutImage={image: this.uploadMedia.image};
        this.formservice.multimedia[0]= (this.rutImage);
      }else {
        this.rutImage={image: this.uploadMedia.image};
        this.formservice.multimedia.push(this.rutImage);
      }
      if(this.formservice.normalpublication.blobsMultimedia.length < 1 ){ //&& this.selectedEcosystem === 'normal'
        this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
      }else{
        this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
      }
 
  }

  public takePhoto(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.cameraService
        .askForMediCapture()
        .then((data: [MediaItem, string]) => {
          if (data[1].toString() === 'camara') {
           
            this.setMultimediaCamera(data[0]);
            resolve(data[0].mediaPath + data[0].nameFile);
          } else if (data[1].toString() === 'camvideo') {
           
            console.log("Estoy en video");
            this.setMultimediaVideo(data[0]);
            resolve(data[0].mediaPath + data[0].nameFile);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  
  

  async pickImage2() {
    const { Camera } = Plugins;
  
    const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
    const videoSourceElement = document.getElementById("videoSource") as HTMLVideoElement;
    if (videoSourceElement) {
      videoSourceElement.muted = true;
      videoSourceElement.defaultMuted = true;
    }
  
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: 'dataUrl',
        source: 'library',
        saveToGallery: false,
        correctOrientation: true,
      });
  
      if (image) {
        const dataUrl = image.dataUrl;
  
        // Update the UI with the selected image
        imagePreviewElement.src = dataUrl;
        videoSourceElement.src = '';
   // Read the file as a Blob
   const response = await fetch(image.mediaPath);
   const blobfile = await response.blob();
 

        // Call the setMultimediaCamera function with the selected image data
        if ( this.formservice.multimedia.length > 0) {
          console.log("Inside normal ecosystem condition");
          this.formservice.multimedia[0] = dataUrl;
        } else {
          this.formservice.multimedia.push(dataUrl);
        }
  
        // Access the media path and name directly
        const mediaPath = image.mediaPath;
        const nameFile = 'PortadaImage';
  
        this.uploadMedia.blob = blobfile;
        this.uploadMedia.filename = image.path ? image.path.substring(image.path.lastIndexOf('/') + 1) : nameFile;
        if(this.formservice.normalpublication.blobsMultimedia.length < 1){
          this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
        }else {
          this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
        }
        // Use the mediaPath and nameFile for further processing
        // ...
      }
    } catch (error) {
      console.log('Error picking image:', error);
    }
  }
  async pickImage(){
    
    const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
    if (Capacitor.getPlatform() === 'android') {
    try {
      const options: CameraOptions = {
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.Uri,
        source: CameraSource.Photos,
        saveToGallery: false,
      };
      console.log('About to call Camera.getPhoto()');
      const media = await Camera.getPhoto(options);
  
      if (media) {

        console.log('Media picked successfully:', media);

      if (Capacitor.getPlatform() === 'web') {
        // For web, create a Blob from the media data and convert it to a data URL
        const response = await fetch(media.webPath);
        const blobfile = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          const imageUrl = reader.result as string;
          if(imagePreviewElement){
            imagePreviewElement.src = imageUrl;
          }
        
          this.formservice.Capacitor_convertFileSrc=imageUrl;
          this.formservice.Capacitor_convertFileSrc_video=null;
          this.formservice.multimedia[0] = { image: imageUrl } as any;
        };
        reader.readAsDataURL(blobfile);
      } else {
        // For iOS and Android, use Capacitor.convertFileSrc to get the public URL
        const imageUrl = Capacitor.convertFileSrc(media.path);
        if(imagePreviewElement){
          imagePreviewElement.src = imageUrl;
        }
        this.formservice.Capacitor_convertFileSrc=imageUrl;
        this.formservice.Capacitor_convertFileSrc_video=null;
        this.formservice.multimedia[0] = { image: imageUrl } as any;
      }
        this.mediaType = media.format === 'jpeg' || media.format === 'png' ? 'image' : 'video';
        this.ref.detectChanges();
        const mimeType = media.format === 'jpeg' ? 'image/jpeg' : media.format === 'png' ? 'image/png' : 'video/mp4';
  
        // Read the file as a Blob
        const response = await fetch(media.webPath);
        const blobfile = await response.blob();
        
  
        // Log the Blob for debugging purposes
        console.log('fileBlob:', blobfile);
        //const filename = media.path.substring(media.path.lastIndexOf('/') + 1);

  this.uploadMedia.blob = blobfile;
  if (Capacitor.getPlatform() !== 'web') {
        this.uploadMedia.filename = media.path.substring(media.path.lastIndexOf('/') + 1);
  }else{
    const currentTime = new Date().toISOString().replace(/:/g, '-').replace(/\./g, '-');
    const sourceName = (media.path || media.webPath || '').split('/').pop() || '';
    const extension = (sourceName.split('.').pop() || media.format || 'jpeg').toLowerCase();
    this.uploadMedia.blob = blobfile;
    this.uploadMedia.filename = `${currentTime}.${extension}`;
  }
        if(this.formservice.normalpublication.blobsMultimedia.length < 1){
          this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
        }else {
          this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
        } 
				this.openWelcomeFirstPostPreviewWhenMediaReady();
        
      }
    } catch (error) {
      console.error('Error picking media:', error);
    }
  }else{
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.multiple = false;
    
    fileInput.addEventListener('change', async (event) => {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (files && files.length > 0) {
     
      const media = files[0];
      console.log('Media picked successfully:', media);
    
      const mimeType = media.type;
    
      // Read the file as a Blob
      const blobfile = media;
    
      const filename = media.name;
    


      const media_URL = URL.createObjectURL(blobfile);
   
      if (imagePreviewElement) {
        imagePreviewElement.src=media_URL;
      }
      this.formservice.Capacitor_convertFileSrc=media_URL;
      this.formservice.Capacitor_convertFileSrc_video=null;
      this.formservice.multimedia[0] = { image: media_URL, typeData: mimeType } as any;
   

    const currentTime = new Date().toISOString().replace(/:/g, '-').replace(/\./g, '-');
    const extension = (filename.split('.').pop() || 'jpeg').toLowerCase();
    this.uploadMedia.blob = blobfile;
    this.uploadMedia.filename = `${currentTime}.${extension}`;
  
        if(this.formservice.normalpublication.blobsMultimedia.length < 1){
          this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
        }else {
          this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
        } 
				this.openWelcomeFirstPostPreviewWhenMediaReady();
      
    
    } else {
      console.log('Media picking cancelled by the user.');
      // Handle cancellation here (e.g., display a message to the user)
    }
    });
    
    fileInput.click();
  }

  }  
  
  
  async pickVideo() {
    if (Capacitor.getPlatform() === 'ios') {
      Swal2.fire({
        title: 'Add videos on your Apple device',
        text: 'To add optimized videos, move the video from your Photos library to your Files app. Then use the optimized option: Choose File',
        icon: 'info',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
    }
    
    const videoPreviewElement = document.getElementById("videoSource") as HTMLVideoElement;
if (videoPreviewElement) {
  videoPreviewElement.muted = true;
  videoPreviewElement.defaultMuted = true;
}
  
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "video/*";
    fileInput.multiple = false;
  
    fileInput.addEventListener("change", () => {
      setTimeout(() => {
      const files = fileInput.files;
  
      if (files && files.length) {
        const file = files[0];

        const mimeType = file.type;


        const blobfile = file;
        const filename = file.name;
       // Create a MediaItem object from the File
      const mediaItem: MediaItem = {
        mediaPath: file.name,
        typeData: file.type,
        nameFile: file.name,
        id: 1, // Assign a unique ID here if needed
        size: file.size,
        index: 0, // Set the desired index value
        route: "", // Set the route value if needed
        status: "", // Set the initial status
        url: "", // Set the URL property
        localUrl: "", // Set the local URL property
        type: "", // Set the type property
        is_premium: 0, // Set the is_premium property
        // Add any other required properties
      };

      this.uploadMedia.blob = blobfile;
      this.uploadMedia.filename = filename;
        if (this.formservice.multimedia.length > 0) {
          this.formservice.multimedia[0] =  mediaItem;
        } else {
          this.formservice.multimedia.push(mediaItem);
        }
        if(this.formservice.normalpublication.blobsMultimedia.length < 1){
          this.formservice.normalpublication.blobsMultimedia[0]={blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename};
        }else {
          this.formservice.normalpublication.blobsMultimedia.push({blob:this.uploadMedia.blob,isPremium:false, filename: this.uploadMedia.filename});
        }
  
        const videoURL = URL.createObjectURL(file);
  
        // Update the video source and display it
        if (videoPreviewElement) {
          videoPreviewElement.src = videoURL;
        }
        this.formservice.Capacitor_convertFileSrc=null;
        this.formservice.Capacitor_convertFileSrc_video=videoURL;
        this.formservice.multimedia[0] = { image: videoURL, typeData: mimeType } as any;
				this.openWelcomeFirstPostPreviewWhenMediaReady();
      }
    }, 999);
    });
  
    // Trigger the file input dialog
    fileInput.click();
  }
  addtime_range(event: any) {
    console.log(event)
    let startValue = event.detail.value;

    this.audio_start_value=startValue;
    console.log("Start Time:", startValue);


   
    // Fetch the audio element dynamically
    const audioElement = document.getElementById('audioSource') as HTMLAudioElement;

    if (!audioElement) {
      console.error('Audio element not found');
      return;
    }

    // Clear any existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Set the audio start time
    audioElement.currentTime = startValue;

    // Play the audio
    audioElement.play();

   let endValue = startValue+30;
   if(endValue>this.audio_duration){
    Swal2.fire({
      title: 'Error',
      text: 'The song must be longer than 30 seconds.',
      icon: 'error',
      confirmButtonText: 'Understood',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
    this.audio_preview_set=false;
    return;
   }else{
    Swal2.fire({
      title: 'Success',
      text: 'The song preview was configured successfully',
      icon: 'success',
      timer: 9999, // Show the alert for 45 seconds
			timerProgressBar: true,
			toast: true,
			position: 'top-start',
      confirmButtonText: 'Understood',
      color: '#ffffff',
      background: '#010f4e',
    });
this.audio_preview_set=true;
   }
    // Set a timeout to pause the audio at the end time
    const duration = (endValue - startValue) * 1000; // duration in milliseconds
    this.timeoutId = setTimeout(() => {
      audioElement.pause();
    }, duration);
  }
  async pickAudio() {
    Swal2.fire({
      title: 'Añade multimedia a tu publicación',
      text: "Selecciona el origen. Al continuar confirmas que la multimedia cumple nuestros términos y no infringe derechos de terceros.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
    if (Capacitor.getPlatform() === 'ios') {
      Swal2.fire({
        title: 'Add audio on your Apple device',
        text: 'To add optimized audio, move audio from your Music library to your Files app. Then use the optimized option: Choose File',
        icon: 'info',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
      });
    }
  
    const audioPreviewElement = document.getElementById("audioSource") as HTMLAudioElement;
  
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "audio/mp3";
    fileInput.multiple = false;
  
    fileInput.addEventListener("change", () => {
      const files = fileInput.files;
  
      if (files && files.length) {
        const file = files[0];
  
        const mimeType = file.type;
        const blobfile = file;
        const filename = file.name;
  
        // Create a MediaItem object from the File
        const mediaItem: MediaItem = {
          mediaPath: file.name,
          typeData: file.type,
          nameFile: file.name,
          id: 1, // Assign a unique ID here if needed
          size: file.size,
          index: 0, // Set the desired index value
          route: "", // Set the route value if needed
          status: "", // Set the initial status
          url: "", // Set the URL property
          localUrl: "", // Set the local URL property
          type: "", // Set the type property
          is_premium: 0, // Set the is_premium property
          // Add any other required properties
        };
  
        this.uploadMedia.blob = blobfile;
        this.uploadMedia.filename = filename;
    
        const audioURL = URL.createObjectURL(file);
        console.log('URLLL',audioURL);
  if(this.audio_blob_set){
return;
  }
        // Update the audio source and display it
        audioPreviewElement.src = audioURL;
    
           
       if (this.formservice.multimedia.length > 0) {
        this.formservice.multimedia[0] = mediaItem;
      } else {
        this.formservice.multimedia.push(mediaItem);
      }

      if(this.formservice.normalpublication.blobsMultimedia.length < 1){
        this.formservice.normalpublication.blobsMultimedia[0] = {blob: this.uploadMedia.blob, isPremium: false, filename: this.uploadMedia.filename};
      } else {
        this.formservice.normalpublication.blobsMultimedia.push({blob: this.uploadMedia.blob, isPremium: false, filename: this.uploadMedia.filename});
      }
      
      }
      this.audio_blob_set=true;
    });
 
    // Trigger the file input dialog
    fileInput.click();
  }
});
  }

  updateDuration(event: Event){
    const audio = event.target as HTMLAudioElement;
    this.audio_duration=audio.duration;
    console.log('audio_duration',this.audio_duration)
   // this.formservice.Capacitor_convertFileSrc_audio = audioURL;
   if(this.audio_duration < 30){
    Swal2.fire({
      title: 'Error',
      text: 'The song must be longer than 30 seconds.',
      icon: 'error',
      confirmButtonText: 'Understood',
      color: '#ffffff',
      background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
    });
    this.closeCreatePublication();
    this.formservice.normalpublication.blobsMultimedia=null;
    this.audio_preview_set=false;
    return;
   }
  }

  onDescriptionChange(value: string) {
    this.formservice.description = this.normalizePublicationDescription(value);
  }

  async onDescriptionPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    if (!clipboardData) {
      return;
    }

    const html = clipboardData.getData('text/html');
    const plainText = clipboardData.getData('text/plain');
    if (!html && !plainText) {
      return;
    }

    event.preventDefault();

    const pastedText = this.normalizePublicationDescription(
      html ? this.convertRichTextToPlainText(html) : plainText
    );
    const textareaElement = await this.getNativeTextarea(event);
    const currentDescription = this.formservice.description || '';
    const start = textareaElement?.selectionStart ?? currentDescription.length;
    const end = textareaElement?.selectionEnd ?? start;
    const nextDescription = this.normalizePublicationDescription(
      currentDescription.slice(0, start) + pastedText + currentDescription.slice(end)
    );

    this.formservice.description = nextDescription;
    this.ref.detectChanges();

    requestAnimationFrame(() => {
      const caretPosition = start + pastedText.length;
      textareaElement?.setSelectionRange(caretPosition, caretPosition);
    });
  }

  private async getNativeTextarea(event: ClipboardEvent): Promise<HTMLTextAreaElement | null> {
    const ionTextarea = event.currentTarget as any;
    if (ionTextarea && typeof ionTextarea.getInputElement === 'function') {
      return ionTextarea.getInputElement();
    }

    return event.target instanceof HTMLTextAreaElement ? event.target : null;
  }

  private convertRichTextToPlainText(html: string): string {
    const container = document.createElement('div');
    container.innerHTML = html;

    container.querySelectorAll('style, script, meta, link').forEach((element) => element.remove());
    container.querySelectorAll('br').forEach((element) => element.replaceWith('\n'));
    container.querySelectorAll('li').forEach((element) => {
      element.insertBefore(document.createTextNode('• '), element.firstChild);
      element.appendChild(document.createTextNode('\n'));
    });
    container.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6').forEach((element) => {
      element.appendChild(document.createTextNode('\n'));
    });

    return container.textContent || '';
  }

  private normalizePublicationDescription(value: string): string {
    return String(value || '')
      .replace(/\r\n?/g, '\n')
      .replace(/\u00a0/g, ' ')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{4,}/g, '\n\n\n');
  }

  async oprimeSiguiente() {

 
    if(this.selectedEcosystem !== 'LK MUSIC'){
    if (this.formservice.normalpublication.blobsMultimedia.length > 0 && this.formservice.title && this.formservice.description && this.formservice.ubicacion) {
      this.siguiente = true;
    } else {
      Swal2.fire({
        title: 'Error en contenido',
        text: 'Porfavor llena todos los campos',
        icon: 'warning',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
      });
    }
  }else {
    if (this.audio_blob_set&&this.audio_preview_set&&this.audio_duration!==30 && this.audio_start_value && this.formservice.normalpublication.blobsMultimedia.length > 1 && this.formservice.title && this.formservice.description && this.formservice.ubicacion) {
      this.siguiente = true;
    } else {
      Swal2.fire({
        title: 'Error en contenido',
        text: 'Porfavor llena todos los campos',
        icon: 'warning',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
    }

  }
  }

  back() {
    if (this.siguiente == false || this.selectedEcosystem === 'LK MUSIC') {
      this.finishModal();
    }
  }
  get_drive_image(){
    Swal2.fire({
			title: 'Usuario de google',
			text: '',
			icon: 'success',
			timer: 9999, // Show the alert for 45 seconds
			timerProgressBar: true,
			toast: true,
			position: 'top-start',
			showConfirmButton: false,
      background: '#010f4e',
		  });

    const fileId = localStorage.getItem('fileId');
    if (fileId) {
      if(this.setDrive_media_called){
        return;
       }else{
         this.setDrive_media_called=true;
       }
      const url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.oauthToken}`
    });
    console.log('Fetched Blob:');

    this.https.get(url, { headers, responseType: 'blob' }).toPromise()
    .then(result => {
      console.log('Fetched Blob:', result);
      let file_type=localStorage.getItem('file_type');
      let file_url= localStorage.getItem('file_url');
        // Create a MediaItem object from the File
           // Generate a timestamp for the filename
           if(file_type=='photo' || file_type =='video'){
          
         
      const timestamp = new Date().toISOString();
      const filename = `file_${timestamp}`;
        const mediaItem: MediaItem = {
          mediaPath: file_url,
          typeData: file_type,
          nameFile: filename,
          id: 1, // Assign a unique ID here if needed
          size: 500,
          index: 0, // Set the desired index value
          route: "", // Set the route value if needed
          status: "", // Set the initial status
          url: "", // Set the URL property
          localUrl: "", // Set the local URL property
          type: "", // Set the type property
          is_premium: 0, // Set the is_premium property
          // Add any other required properties
        };
    
        this.uploadMedia.blob = result;
        this.uploadMedia.filename = filename;
        if(file_type=='photo' || file_type==='video' ){
          Swal2.fire({
            title: '',
            text: '',
            icon: 'success',
            timer: 9999, // Show the alert for 45 seconds
            timerProgressBar: true,
            toast: true,
            position: 'top-start',
            showConfirmButton: false
            });
        }else{
          Swal2.fire({
            title: 'Solo puedes subir fotos o videos',
            text: 'Make sure to select a photo or video. If the error persists, contact Laniakea support.',
            icon: 'error',
            timer: 9999, // Show the alert for 45 seconds
            timerProgressBar: true,
            toast: true,
            position: 'top-start',
            showConfirmButton: false
            });
            return;
        }
        if (this.formservice.multimedia.length > 0) {
          this.formservice.multimedia[0] = mediaItem;
        } else {
          this.formservice.multimedia.push(mediaItem);
        }
  
        if(this.formservice.normalpublication.blobsMultimedia.length < 1){
          this.formservice.normalpublication.blobsMultimedia[0] = {blob: this.uploadMedia.blob, isPremium: false, filename: this.uploadMedia.filename};
        } else {
          this.formservice.normalpublication.blobsMultimedia.push({blob: this.uploadMedia.blob, isPremium: false, filename: this.uploadMedia.filename});
        }
  
        const media_URL = URL.createObjectURL(result);

        console.log(file_type);

        console.log(file_url);
        if(file_type=='photo'){
          
          const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
if(imagePreviewElement){

          imagePreviewElement.src=media_URL;
          this.formservice.Capacitor_convertFileSrc=media_URL;
          clearInterval(this.setDrive_media);
            
}
        }else if(file_type=='video'){

          const videoPreviewElement = document.getElementById("videoSource") as HTMLVideoElement;
if (videoPreviewElement) {
  videoPreviewElement.muted = true;
  videoPreviewElement.defaultMuted = true;
}
          if(videoPreviewElement){
          videoPreviewElement.src=media_URL;
          this.formservice.Capacitor_convertFileSrc_video=media_URL;
          clearInterval(this.setDrive_media);
        }
        }
      }else{
        Swal2.fire({
          title: 'Error en contenido',
          text: 'Solo puedes subir fotos o videos',
          icon: 'warning',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
       }
    })
    .catch(error => {
      console.error('Error fetching blob:', error);
    });
        
    

      
    }
   
  
  }
  finishModal() {
    Swal2.fire({
      title: 'Estas seguro de regresar?',
      text: "Tenga en cuenta perdera todo el proceso de este apartado",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.closeCreatePublication();
      }
    });
  }

  private async closeCreatePublication(fallbackRoute: string = '/home/ecosystem-page') {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
      return;
    }

    // This page is also opened from Mycelium, onboarding, profile, and other
    // feeds. Preserve the route that launched it instead of forcing every
    // dismissal into the ecosystem home route.
    const navigationId = Number(window.history.state?.navigationId || 0);
    if (navigationId > 1) {
      this.location.back();
      return;
    }

    await this.router.navigateByUrl(fallbackRoute, { replaceUrl: true });
  }

  askForLibraryCapture(take_photo: boolean = true, pick_AI: boolean = true, pick_image: boolean = true,pick_video: boolean = true,  pick_GOOGLE: boolean = true,) {
    if (Capacitor.getPlatform() === 'ios' && this.selectedEcosystem === 'normal' && !this.entrelazamiento) {
      void this.openNormalMediaComposer();
      return;
    }
    Swal2.fire({
      title: 'Escoge un archivo para subir desde tu dispositivo.',
      text: "By uploading, you confirm that the multimedia complies with our Terms and Conditions and does not infringe anyone else's rights.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
     
		return new Promise((resolve, reject) => {

			let botonesDisponibles = [
				(this.formservice.publication_type === 'normal') ?
					{
						text: 'Usar URL de multimedia',
						icon: 'link',
						handler: () => {
							this.promptForExistingMediaUrl()
								.then((accepted) => resolve([accepted, 'remote_url']))
								.catch((error) => reject(error));
						}
					} : null,
				(pick_image) ?
					{
						text: 'Seleccionar una foto',
						icon: 'camera',
						handler: () => {
							console.log("oprimiste camara");

							this
                             .pickImage()
                             .then((mediaItem) => {
                               resolve([mediaItem,'camara']);
                             })
                             .catch((error) => {
                               Swal2.fire({
                                 title: 'Error take photo',
                                 text: error,
                                 icon: 'warning',
                                 confirmButtonText: 'Understood',
                                 color: '#ffffff',
                                 background: '#010f4e',
                                 position: 'top-end',
                                 timerProgressBar: true,
                                 toast: true,
                               });
                             });
						}
					} : null,
          
				(pick_video) ?

					{
						text: 'Select a video',
						icon: 'videocam',
						handler: () => {
              if(this.formservice.publication_type !== 'LK MUSIC'){
                this
                .pickVideo()
                .then((mediaItem) => {
                  resolve([mediaItem,'camvideo']);
                })
                .catch((error) => {
                  Swal2.fire({
                    title: 'Error al capturar video',
                    text: error,
                    icon: 'warning',
                    confirmButtonText: 'Understood',
                    color: '#ffffff',
                    background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                  });
                });
              }else{
                Swal2.fire({
                  title: 'Error al capturar video',
                  text: 'Uploading videos to LK MUSIC is currently unavailable',
                  icon: 'warning',
                  confirmButtonText: 'Understood',
                  color: '#ffffff',
                  background: '#010f4e',
                  position: 'top-end',
                  timerProgressBar: true,
                  toast: true,
                });
              }
							console.log("oprimiste video");

						}
					} : null,
          (pick_AI) ?
					{
						text: 'Create quantum cover photo',
						icon: 'images',
						handler: () => {
							console.log("oprimiste texto a imagen");

							this.AI().then((mediaItem) => {
                               resolve([mediaItem,'images']);
                             })
                             .catch((error) => {
                               Swal2.fire({
                                 title: 'Error take photo',
                                 text: error,
                                 icon: 'warning',
                                 confirmButtonText: 'Understood',
                                 color: '#ffffff',
                                 background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                               });
                             });
						}
					} : null,
          
          (pick_GOOGLE) ?
          {
            
						text: 'Google Drive',
						icon: 'logo-google',
						handler: () => {
							console.log("oprimiste texto a imagen");
if( localStorage.getItem('fileId')){
  Swal2.fire({
    title: 'Solo puedes agregar una portada',
    text: 'Ya agregasete una portada',
    icon: 'error',
    confirmButtonText: 'Understood',
    color: '#ffffff',
    background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
  });
  return;
}
							this.loadGooglePicker().then((mediaItem) => {
                               resolve([mediaItem,'images']);
                             })
                             .catch((error) => {
                               Swal2.fire({
                                 title: 'Error take photo',
                                 text: error,
                                 icon: 'warning',
                                 confirmButtonText: 'Understood',
                                 color: '#ffffff',
                                 background: '#010f4e',
                                 position: 'top-end',
                                 timerProgressBar: true,
                                 toast: true,
                               });
                             });
						}
					} : null,

				{
					text: 'Cancel',
					icon: 'close',
					role: 'cancel',
					handler: () => {
					}
				}
			];

			botonesDisponibles = botonesDisponibles.filter((boton) => {
				if (boton != null) {
					return true;
				}
				return false;
			});


			this.actionSheetController.create({
				header: 'Where would you like to add multimedia from?',
				cssClass: 'options-sheet',
				buttons: botonesDisponibles
			}).then(async (actionSheet) => {
				const isIOS = Capacitor.getPlatform() === 'ios';
				try {
					if (isIOS) {
						await NativeLiquidGlass.setChromeSuppressed({ suppressed: true });
					}
					await actionSheet.present();
					await actionSheet.onDidDismiss();
				} catch (error) {
					console.error('Unable to present media source action sheet.', error);
				} finally {
					if (isIOS) {
						await NativeLiquidGlass.setChromeSuppressed({ suppressed: false }).catch(() => undefined);
						await NativeLiquidGlass.restoreRegions().catch(() => undefined);
					}
				}
			});
		});
  }
});
	}

  public async AI(){
    this.closeCreatePublication('/home/messages-page');
    // Use the Router to navigate to the "messages-page"
    this.router.navigate(['home/messages-page']);
    this.formservice.fromCreatePublication=true;
    this.router.navigateByUrl('home/messages-page', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }
  onUbicacionChange(event: any) {
    
    this.formservice.ubicacion = event.detail.value;
    this.formservice.normalpublication.ubicacion=this.formservice.ubicacion;
    this.formservice.lkpublication.ubicacion = this.formservice.ubicacion;
    this.formservice.landpublication.ubicacion = this.formservice.ubicacion;
    this.formservice.epochpublication.ubicacion = this.formservice.ubicacion;
    this.formservice.eventospublication.ubicacion = this.formservice.ubicacion;
    this.formservice.earthpublication.ubicacion = this.formservice.ubicacion;
    console.log('ubicacion:', this.formservice.ubicacion)
  }
  postEntrelazamiento(){
    if(this.formservice.normalpublication.blobsMultimedia.length > 1 && this.formservice.description){

	  this.formservice.normalpublication.blobsMultimedia.forEach(element => {
      console.log("Elemento",element);
      this.uploadMultimediaService.post(element.blob, element.filename).then(({ link, mimeType }) => {
        const ruta = link;
       // const ruta = r[0];
        //const mimeType = r[1];
        console.log('ruta', ruta);
        let pub_type = '';
        //console.log(this.multimedia[0].typeData);
        if(mimeType.includes("image")) {
          pub_type= 'imagen';
        }else if(mimeType.includes("video")){
          pub_type= 'video';
        }
        let is_premium_m: boolean;
        console.log('is premium', element.isPremium);
        if(element.isPremium === undefined){
          console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
          is_premium_m = this.formservice.normalpublication.current_multimedia_status;
        }else{
          is_premium_m = element.isPremium;
        }
        const objmedia = {
          route: ruta,
          size: 800,
          type:pub_type,
          bio:this.formservice.description
        //  publication_type: this.formservice.publication_type,
    //      publication_id: publication_ids[0],
     //     is_premium: is_premium_m
        };
        console.log('objmedia', objmedia);
        this.request.createRequestPost('PostingEntrelazamientoContnent',objmedia).then((final_data) => {
          console.log('request history final data',final_data);
          this.closeCreatePublication();
        }).catch((error) => {

          Swal2.fire({
            title: 'Error al subir multimedia!',
            text: error,
            icon: 'warning',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          });

        });

      });
    });
  }else{
    Swal2.fire({
      title: 'Error al subir contenido!',
      text: 'Make sure to select at least 2 images and a biography',
      icon: 'warning',
      confirmButtonText: 'Understood',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
  }
  }
  async loadGooglePicker() {
    const data = await this.googleAccountAuth.requireAuthentication('drive');
    if (!data) {
      return null;
    }

      this.user_id=data.user_id;
      console.log('user_id', this.user_id);
      this.oauthToken=data.token;
      Swal2.fire({
        title: 'Usuario de GOOGLE',
        text: 'The user has been authenticated',
        icon: 'success',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
    this.setDrive_media=  setInterval(() => {
      this.get_drive_image();
      }, 2100);
      this.onPickerApiLoad();
      return data;
  }



  onPickerApiLoad() {
 
  
      const script = document.createElement('script');
      script.src = 'https://apis.google.com/js/api.js';
      script.onload = () => {
        gapi.load('picker', {
          'callback': () => {
            this.createPicker();

          }
        });
      };

      document.body.appendChild(script);


  }


  createPicker() {
    if (this.oauthToken) {
      const picker = new google.picker.PickerBuilder()
        .addView(google.picker.ViewId.DOCS)
        .setOAuthToken(this.oauthToken)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setAppId('laniakea-393417')
        .setDeveloperKey(this.apiKey)
        .setCallback(this.pickerCallback.bind(this))
        .build();
      picker.setVisible(true);
    }
  }

  async pickerCallback(data: any) {
    if (data.action === google.picker.Action.PICKED) {
      const fileId = data.docs[0].id;
      console.log('Selected File ID:', fileId);

      console.log('Selected File ID:', data.docs[0]);
      localStorage.setItem('fileId', fileId);
      localStorage.setItem('file_type', data.docs[0].type);
      localStorage.setItem('file_url', data.docs[0].embedUrl);
        const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
        const videoPreviewElement = document.getElementById("videoSource") as HTMLVideoElement;
if (videoPreviewElement) {
  videoPreviewElement.muted = true;
  videoPreviewElement.defaultMuted = true;
}
        console.log('get_blob', this.oauthToken);
     //get_blob(fileId, data.docs[0])
    }
  }

  addPrice(event) {
    const inputPrice = parseInt(event.target.value);
    const limitedPrice = Math.min(inputPrice, 999);
    this.formservice.price = limitedPrice > 999 ? 999 : limitedPrice;
  }


}
async function get_blob(fileId, fileData) {
 let profile_id =localStorage.getItem('profile_id');
  try {
      const request = {
          fileId: fileId,
         // profile_id: profile_id
      };
      
   // Construct the URL with query parameters
   let loginUrl = `https://9jkrdd2hdl.execute-api.us-east-1.amazonaws.com/get_blob_from_drive_file?fileId=${encodeURIComponent(fileId)}&profile_id=${encodeURIComponent(profile_id)}`;
      let response = await fetch(loginUrl, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(request)
      });

      if (!response.ok) {
          throw new Error('Network response was not ok');
      }

      let binary = await response.text();
      let l = binary.length;
      let array = new Uint8Array(l);
      for (let i = 0; i < l; i++) {
          array[i] = binary.charCodeAt(i);
      }
      let blob = new Blob([array], { type: fileData.mimeType });

      if (fileData.mimeType.startsWith('image/')) {
          const imagePreviewElement = document.getElementById("imagePreview");
          imagePreviewElement.style.display = 'block';
        //  imagePreviewElement.src = URL.createObjectURL(blob);
      } else if (fileData.mimeType.startsWith('video/')) {
          const videoPreviewElement = document.getElementById("videoSource") as HTMLVideoElement;
          videoPreviewElement.style.display = 'block';
          videoPreviewElement.muted = true;
          videoPreviewElement.defaultMuted = true;
        //  videoPreviewElement.src = URL.createObjectURL(blob);
      }

      // Additional logic to handle the blob (e.g., upload to server, etc.)
  } catch (error) {
      console.error('Error fetching the blob:', error);
  }
  
}
